module.exports = __webpack_public_path__ + "img/Media-Information.6033824b.svg";